import React, { useEffect, useState } from 'react';

interface LeafProps {
  id: number;
  left: string;
  delay: string;
  duration: string;
  size: number;
  rotation: number;
}

const NUM_LEAVES = 30; // Jumlah daun yang akan ditampilkan

const FloatingLeaves: React.FC = () => {
  const [leaves, setLeaves] = useState<LeafProps[]>([]);

  useEffect(() => {
    const generatedLeaves: LeafProps[] = Array.from({ length: NUM_LEAVES }).map((_, i) => ({
      id: i,
      left: `${Math.random() * 100}vw`, // Posisi horizontal acak
      delay: `${Math.random() * 15}s`, // Penundaan mulai acak
      duration: `${10 + Math.random() * 10}s`, // Durasi acak antara 10s dan 20s
      size: 20 + Math.floor(Math.random() * 20), // Ukuran acak antara 20px dan 40px
      rotation: Math.floor(Math.random() * 360), // Rotasi awal acak
    }));
    setLeaves(generatedLeaves);
  }, []);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
      {leaves.map((leaf) => (
        <div
          key={leaf.id}
          className="absolute -top-20"
          style={{
            left: leaf.left,
            animation: `leafFallSway ${leaf.duration} cubic-bezier(0.45, 0.05, 0.55, 0.95) ${leaf.delay} infinite`,
            opacity: 0.7 + Math.random() * 0.3, // Opacity acak untuk depth effect
          }}
        >
          {/* SVG Mangrove Leaf - bentuk realistis seperti daun asli */}
          <svg
            width={leaf.size}
            height={leaf.size * 1.5}
            viewBox="0 0 100 150"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              transform: `rotate(${leaf.rotation}deg)`,
              filter: 'drop-shadow(0 3px 10px rgba(0,0,0,0.5))',
            }}
          >
            {/* Outline putih untuk kontras */}
            <ellipse
              cx="50"
              cy="75"
              rx="32"
              ry="52"
              fill="none"
              stroke="white"
              strokeWidth="3"
              opacity="0.9"
            />
            
            {/* Daun mangrove - bentuk oval/ellipse natural */}
            <ellipse
              cx="50"
              cy="75"
              rx="30"
              ry="50"
              fill="url(#leafGradient)"
              opacity="0.95"
            />
            
            {/* Gradient untuk efek 3D */}
            <defs>
              <linearGradient id="leafGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#22c55e" stopOpacity="1" />
                <stop offset="50%" stopColor="#16a34a" stopOpacity="1" />
                <stop offset="100%" stopColor="#15803d" stopOpacity="1" />
              </linearGradient>
              <radialGradient id="leafHighlight" cx="40%" cy="40%">
                <stop offset="0%" stopColor="#4ade80" stopOpacity="0.6" />
                <stop offset="100%" stopColor="#16a34a" stopOpacity="0" />
              </radialGradient>
            </defs>
            
            {/* Highlight untuk efek cahaya */}
            <ellipse
              cx="40"
              cy="60"
              rx="15"
              ry="25"
              fill="url(#leafHighlight)"
            />
            
            {/* Urat daun tengah (midrib) */}
            <line
              x1="50"
              y1="25"
              x2="50"
              y2="125"
              stroke="#0f5132"
              strokeWidth="2"
              opacity="0.8"
            />
            
            {/* Urat daun samping kiri */}
            <path
              d="M 50 40 Q 35 50 30 65"
              stroke="#0f5132"
              strokeWidth="1"
              fill="none"
              opacity="0.6"
            />
            <path
              d="M 50 60 Q 35 70 32 85"
              stroke="#0f5132"
              strokeWidth="1"
              fill="none"
              opacity="0.6"
            />
            <path
              d="M 50 80 Q 38 90 35 105"
              stroke="#0f5132"
              strokeWidth="1"
              fill="none"
              opacity="0.6"
            />
            
            {/* Urat daun samping kanan */}
            <path
              d="M 50 40 Q 65 50 70 65"
              stroke="#0f5132"
              strokeWidth="1"
              fill="none"
              opacity="0.6"
            />
            <path
              d="M 50 60 Q 65 70 68 85"
              stroke="#0f5132"
              strokeWidth="1"
              fill="none"
              opacity="0.6"
            />
            <path
              d="M 50 80 Q 62 90 65 105"
              stroke="#0f5132"
              strokeWidth="1"
              fill="none"
              opacity="0.6"
            />
            
            {/* Tangkai daun */}
            <line
              x1="50"
              y1="125"
              x2="50"
              y2="145"
              stroke="#0a3d1f"
              strokeWidth="3"
              opacity="0.9"
              strokeLinecap="round"
            />
          </svg>
        </div>
      ))}
    </div>
  );
};

export default FloatingLeaves;
